import Cookies, { CookieAttributes } from 'js-cookie';
import { getEnvironmentName } from 'utils/environment';

export const setCookie = (name: string, value: string, options?: CookieAttributes): void => {
  Cookies.set(name, value, options);
};

export const setSecureCookie = (name: string, value: string, options?: CookieAttributes): void => {
  Cookies.set(name, value, { ...secureAttributes(), ...options });
};

export const getCookie = (name: string): string | undefined => {
  return Cookies.get(name);
};

export const secureAttributes = (): CookieAttributes => ({
  sameSite: 'strict',
  secure: Boolean(getEnvironmentName() !== 'local'),
});
